<ds-metadata-field-wrapper [label]="label | translate">
  <span
    class="dont-break-out"
    *ngFor="let mdValue of mdValues; let last = last"
  >
    {{ toUpperCase ? (mdValue.value | uppercase) : mdValue.value
    }}<span *ngIf="!last" [innerHTML]="separator"></span>
  </span>
</ds-metadata-field-wrapper>
